import React, { memo } from 'react'

const CopyIcon: React.FC = memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="7.57352"
      y="7.15"
      width="11.6765"
      height="12.1"
      rx="1.25"
      stroke="#ffffff"
      strokeWidth="1.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 5.5H15.1765C15.4526 5.5 15.6765 5.72386 15.6765 6V6.4H17.1765V6C17.1765 4.89543 16.281 4 15.1765 4H6C4.89543 4 4 4.89543 4 6V15.6C4 16.7046 4.89543 17.6 6 17.6H6.82353V16.1H6C5.72386 16.1 5.5 15.8761 5.5 15.6V6C5.5 5.72386 5.72386 5.5 6 5.5Z"
      fill="#ffffff"
    />
  </svg>
))

export { CopyIcon }
